<p @tooltip class="{{ direction }}">{{ message }}</p>
